import axios from 'axios';

const URI = process.env.REACT_APP_API_PATh.toString();

export async function createDrugstore (req, res) {
  try {
    const response = await axios.post(`${URI}/farmacia`, req);
    return response.data;

  } catch (err) {
    console.log(err)
  }
}

export async function getDrugstores (req, res) {
  try {
    const response = await axios.get(`${URI}/farmacia`);
    return response.data;

  } catch (err) {
    console.log(err)
  }
}

export async function deleteDrugstore (id) {
  console.log(id)
  try {
    const response = await axios.delete(`${URI}/farmacia/${id}`);
    return response.data;

  } catch (err) {
    console.log(err)
  }
}

export async function updateDrugstore (id, req) {
  try {
    const response = await axios.put(`${URI}/farmacia/${id}`, req);
    return response.data;

  } catch (err) {
    console.log(err)
  }
}